import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import ListItemText from '@material-ui/core/ListItemText'
import Select from '@material-ui/core/Select'
import { MySelectCtrlType, SelectViewType } from './selectType'
import useMultiSelect from './useSelect'
import { FormHelperText, Grid, Typography } from '@material-ui/core'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 6.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
    getContentAnchorEl: null,
}

let SelectView: React.FC<SelectViewType> = ({
    handleValueChange,
    onChangeSelect,
    field,
    required,
    maxLength,
    materialInputProps = {},
    icon,
    defaultValue,
    resetButtom = false,
    label = '',
    option,
    disabled,
    placeholder,
    size = 'small',
    ...props
}) => {
    const { input, meta } = field

    const isError = meta.error && meta.invalid && meta.touched ? true : false
    const classes = useStyles(isError)
    const [valueList, setValueList] = React.useState<number[]>([])

    React.useEffect(() => {
        if (!input.value) {
            setValueList([])
        }
    }, [input.value])

    React.useEffect(() => {
        if (defaultValue) {
            setValueList(defaultValue as number[])
        }
    }, [JSON.stringify(defaultValue)])

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const value = event.target.value as any
        input.onChange(value as any)
        setValueList([value] as number[])
        if (onChangeSelect) onChangeSelect(value as any)
    }

    const getLabel = () => {
        const displayIcon = icon && <Grid item>{icon}</Grid>
        const myLabel = required ? (
            <Grid container className={classes.label}>
                <Grid item>
                    <Typography variant={'subtitle2'}>{label || ''}</Typography>
                </Grid>
                <Grid item>
                    <Typography variant={'subtitle2'} style={{ color: 'red' }}>
                        {label ? `*` : ''}
                    </Typography>
                </Grid>
                &nbsp;{displayIcon}
            </Grid>
        ) : (
            <Grid container className={classes.label}>
                <Grid item>
                    <Typography variant={'subtitle2'}>{label || ''}</Typography>
                </Grid>
                &nbsp;{displayIcon}
            </Grid>
        )
        return <Typography variant={'subtitle2'}>{myLabel}</Typography>
    }
    return (
        <div>
            <FormControl variant="outlined" size={size} fullWidth>
                {getLabel()}
                <Select
                    // native

                    error={isError}
                    disabled={disabled}
                    value={valueList && valueList.length > 0 ? valueList : []}
                    onChange={handleChange}
                    displayEmpty={true}
                    className={disabled ? classes.disable : classes.myStyle}
                    renderValue={(selected) => {
                        const selectedItem = selected as any[]

                        if (selectedItem && selectedItem.length > 0) {
                            var filtered = option?.filter(function (e) {
                                return selectedItem.indexOf(e.value) > -1
                            })

                            let listLabel: any[] = []
                            if (filtered) {
                                listLabel = filtered.slice(-1).map((itm: any) => {
                                    return itm.label
                                })
                            }

                            return listLabel as string[]
                        } else {
                            return <label style={{ color: '#aaaaa9' }}>{placeholder}</label>
                        }
                    }}
                    MenuProps={{
                        ...MenuProps,
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                    }}
                >
                    {option &&
                        option.map((optionItm) => (
                            <MenuItem key={optionItm.value} value={optionItm.value}>
                                <ListItemText primary={optionItm.label} />
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
            <FormHelperText className={classes.errorText}>
                {/* {!materialInputProps?.disabled && meta.error && meta.touched && meta.error} */}
                {isError && meta.error}
            </FormHelperText>
        </div>
    )
}

let MySelectCtrl: React.FC<MySelectCtrlType> = ({
    handleValueChange,
    name,
    required,
    validates,
    maxLength,
    ...props
}) => {
    const mySelect = useMultiSelect({
        name,
        required,
        validates,
    })
    return <SelectView required={required} {...mySelect} {...props} />
}

export default MySelectCtrl

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
    label: {
        marginBottom: 10,
        color: (isError: any) => {
            if (isError) {
                return '#ff4d4f'
            } else {
                return ''
            }
        },
    },
    myStyle: {
        borderRadius: '8px ',
    },
    disable: { backgroundColor: '#F0F0F0C6', borderRadius: '8px ' },
    errorText: {
        // fontFamily: 'prompt',
        fontSize: '12px',
        color: '#ff4d4f',
    },
}))
